import { BottomSheetExtendedProps } from '@bonanza-social/navigation';
import { OnboardingStep } from '../../state/onboarding.types';

export enum OnboardingAction {
  OPEN_CHAT = 'OPEN_CHAT',
  OPEN_ONFIDO = 'OPEN_ONFIDO',
}

export type OnboardingBottomSheetProps = BottomSheetExtendedProps & {
  step: OnboardingStep;
};
